import { render, staticRenderFns } from "./GscbArticle.vue?vue&type=template&id=10f55464&scoped=true"
import script from "./GscbArticle.vue?vue&type=script&lang=js"
export * from "./GscbArticle.vue?vue&type=script&lang=js"
import style0 from "./GscbArticle.vue?vue&type=style&index=0&id=10f55464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f55464",
  null
  
)

export default component.exports